(function ($) {
	$(document).ready(function () {
		// Initially hide the container completely
		$("#hive-popups-container").hide();

		// Process each popup
		$(".hive-popup").each(function () {
			var $popup = $(this);
			var trigger = $popup.data("trigger");

			// Prevent from being shown again
			var popupId = $popup.attr("id");
			if (localStorage.getItem(popupId)) {
				return;
			}

			// Handle triggers
			switch (trigger) {
				case "load":
					setTimeout(function () {
						showPopup($popup);
					}, 1000);
					break;

				case "scroll":
					var scrollPercent = $popup.data("scroll");
					var scrollTriggered = false;

					$(window).on("scroll.popup", function () {
						if (scrollTriggered) return;

						var docHeight = $(document).height() - $(window).height();
						var scrollPos = $(window).scrollTop();
						var scrollPercentage = (scrollPos / docHeight) * 100;

						if (scrollPercentage > scrollPercent) {
							showPopup($popup);
							scrollTriggered = true;
							$(window).off("scroll.popup");
						}
					});
					break;

				case "exit":
					$(document).on("mouseleave.popup", function (e) {
						if (e.clientY < 0) {
							showPopup($popup);
							$(document).off("mouseleave.popup");
						}
					});
					break;
			}
		});

		// Function to show popup
		function showPopup($popup) {
			// Show container
			$("#hive-popups-container").show();

			// Show popup with flex display
			$popup.css("display", "flex");

			// Lock scrolling
			$("body").addClass("popup-open");
		}

		// Function to hide popup
		function hidePopup($popup) {
			$popup.fadeOut(300, function () {
				// If no popups are visible, hide container completely
				if ($(".hive-popup:visible").length === 0) {
					$("#hive-popups-container").hide();
					$("body").removeClass("popup-open");
				}
			});

			// Mark as seen
			localStorage.setItem($popup.attr("id"), "1");
		}

		// Close popup on click
		$(document).on("click", ".hive-popup-close, .hive-popup", function (e) {
			if (e.target === this || $(this).hasClass("hive-popup-close")) {
				var $popup = $(this).closest(".hive-popup");
				hidePopup($popup);
			}
		});

		// Close on ESC key
		$(document).on("keyup", function (e) {
			if (e.key === "Escape" && $(".hive-popup:visible").length > 0) {
				$(".hive-popup:visible").each(function () {
					hidePopup($(this));
				});
			}
		});
	});
})(jQuery);
